<ng-container class="spinner-container">
	<div fxLayout="row" fxFill style="position: relative; top: 0">
		<mat-card
			style="
				margin: 20px;
				background: linear-gradient(#242424, #141414);
				width: 95%;
			"
			class="mobile-mat-card"
			ngClass.xs="shotdata-xs"
			ngClass.lt-md="shotdata-xs"
			(window:resize)="onResize()"
		>
			<mat-card-header>
				<div
					fxLayout="row"
					fxLayoutAlign="space-between"
					style="width: 100%"
				>
					<div fxLayout="row">
						<img
							data-idtest="shotdata-a-7Wy"
							src="/images/shotdata_logo.png"
							style="width: 32px"
						/>
						<div>
							<div
								data-idtest="shotdata-t-6Ru"
								class="card-title mobile-font-12"
								translate
							>
								スイングチェック
							</div>
							<div
								data-idtest="shotdata-t-7Mp"
								class="card-title"
								style="font-size: 10px; padding-top: 5px"
							>
								AIGIA Swing data analyzing
							</div>
						</div>
					</div>
					<div fxLayout="row" style="align-items: center">
						<div
							*ngIf="auth | aigauthis : 'trainer'"
							style="margin: 0 4px"
						>
							<mat-slide-toggle
								data-idtest="shotdata-s-9Vl"
								[(ngModel)]="isRelated"
								(change)="onFind()"
								><span style="font-weight: 900" translate class="mobile-font-14"
									>生徒を含む</span
								></mat-slide-toggle
							>
						</div>
					</div>
				</div>
			</mat-card-header>
			<mat-card-content>
				<div fxLayout="column" style="margin: 14px 0 8px 0">
					<mat-accordion multi>
						<mat-expansion-panel
							(closed)="panelChange('find', false)"
							(opened)="panelChange('find', true)"
							[expanded]="conditions_panels.open_find"
							style="box-shadow: none; background: #242424"
							class="mobile-bg-black"
						>
							<mat-expansion-panel-header
								class="section-bar-header"
								style="background-color: #99774a"
							>
								<mat-panel-title
									class="section-bar gold"
									fxLayoutAlign="space-between"
								>
									<span
										style="
											padding-left: 12px;
											font-weight: 900;
										"
										fxLayout="row"
									>
										<mat-icon
											data-idtest="shotdata-a-1Dg"
											class="hide-mobile"
											>search</mat-icon
										>
										<span
											data-idtest="shotdata-a-1Dg"
											style="padding-right: 4px"
											class="hide-pc"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="18"
												height="18"
												viewBox="0 0 24 24"
												fill="none"
												stroke="currentColor"
												stroke-width="2"
												stroke-linecap="round"
												stroke-linejoin="round"
												class="lucide lucide-filter h-5 w-5 text-white"
											>
												<polygon
													points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
												></polygon></svg
										></span>
										<div
											data-idtest="shotdata-t-6Qx"
											style="align-self: center"
											translate
										>
											絞り込み
										</div>
									</span>
								</mat-panel-title>
								<mat-panel-description
									class="section-bar-close-button"
								>
									<span *ngIf="conditions_panels.open_find">
										<span
											data-idtest="shotdata-t-0Zw"
											translate
											>閉じる</span
										><img
											src="/icons/arrow_up.png"
											style="width: 18px; padding: 0 8px"
										/>
									</span>
									<span *ngIf="!conditions_panels.open_find">
										<span
											data-idtest="shotdata-t-3Df"
											translate
											>開く</span
										><img
											src="/icons/arrow_down.png"
											style="width: 18px; padding: 0 8px"
										/>
									</span>
								</mat-panel-description>
							</mat-expansion-panel-header>
							<div fxLayout="column">
								<div
									fxLayout="row"
									fxLayout.lt-sm="column"
									fxLayout.lt-md="column"
									fxLayoutAlign="space-between"
									style="background: #191919"
									class="upper-row mobile-bg-black"
								>
									<div
										fxLayout="row"
										fxLayout.lt-sm="column"
										fxLayout.lt-md="column"
										fxFlex="40"
										fxFlex.lt-md="100"
										fxFlex.lt-sm="100"
									>
										<div
											class="title-content date mobile-bg-black"
											fxFlex="15"
											fxFlex.lt-md="100"
											fxFlex.lt-sm="100"
										>
											<div
												data-idtest="shotdata-t-1Yc"
												style="font-weight: 900"
												translate
											>
												日時
											</div>
										</div>
										<div
											fxLayout="row"
											fxFlex="85"
											class="mobile-w100"
										>
											<mat-form-field
												appearance="outline"
												fxFlex="47"
												class="mobile-w50"
											>
												<mat-label
													><span
														data-idtest="shotdata-t-3Na"
														translate
														>日(From)</span
													></mat-label
												>
												<input
													data-idtest="shotdata-i-0Nb"
													[(ngModel)]="
														current_field.create
															.from
													"
													[matDatepicker]="from"
													matInput
													(dateChange)="
														this.onResetSelectAvgShotOrigin()
													"
												/>
												<mat-datepicker-toggle
													[for]="from"
													matSuffix
												></mat-datepicker-toggle>
												<mat-datepicker
													#from
												></mat-datepicker>
											</mat-form-field>

											<div
												class="hide-mobile"
												data-idtest="shotdata-t-7Yv"
												style="
													padding-right: 12px;
													display: flex;
													align-items: center;
												"
											>
												~
											</div>

											<mat-form-field
												appearance="outline"
												fxFlex="47"
												class="mobile-w50"
											>
												<mat-label
													><span
														data-idtest="shotdata-t-2Jb"
														translate
														>日(To)</span
													></mat-label
												>
												<input
													data-idtest="shotdata-i-5Yh"
													[(ngModel)]="
														current_field.create.to
													"
													[matDatepicker]="to"
													matInput
													(dateChange)="
														this.onResetSelectAvgShotOrigin()
													"
												/>
												<mat-datepicker-toggle
													[for]="to"
													matSuffix
												></mat-datepicker-toggle>
												<mat-datepicker
													#to
												></mat-datepicker>
											</mat-form-field>
										</div>
									</div>

									<div fxLayout="row" fxFlex="85">
										<div
											*ngIf="auth | aigauthis : 'user'"
											fxLayout="row"
											fxLayout.lt-sm="column"
											fxLayout.lt-md="column"
											fxFlex="56"
											fxFlex.lt-md="50%"
											fxFlex.lt-sm="50%"
										>
											<div
												class="title-content club mobile-bg-black"
												fxFlex="40"
											>
												<div
													data-idtest="shotdata-t-8Pj"
													style="font-weight: 900"
													translate
												>
													クラブ種類
												</div>
											</div>
											<mat-form-field
												appearance="outline"
												fxFlex.lt-sm="60"
												fxFlex.lt-xl="54"
												fxFlex.lt-md="60"
												class="club-field"
											>
												<!-- <mat-label>クラブ</mat-label> -->
												<mat-select
													data-idtest="shotdata-s-8Xh"
													[(value)]="
														current_field.club
													"
													(selectionChange)="
														this.onResetSelectAvgShotOrigin()
													"
													class="select-group"
												>
													<mat-option
														*ngFor="
															let club of clubs
														"
														[value]="club.value"
													>
														{{ club.name }}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>

										<div
											fxLayout="row"
											fxLayout.lt-sm="column"
											fxLayout.lt-md="column"
											fxFlex="56%"
											fxFlex.lt-md="50%"
											fxFlex.lt-sm="50%"
											class="hide-pc"
										>
											<div
												class="title-content fav mobile-bg-black"
												fxFlex="40%"
											>
												<div
													data-idtest="shotdata-t-6Ig"
													style="font-weight: 900"
													translate
												>
													お気に入り
												</div>
											</div>

											<mat-form-field
												appearance="outline"
												fxFlex="54%"
												fxFlex.lt-md="60%"
												fxFlex.lt-sm="60%"
												class="fav-field"
											>
												<mat-select
													data-idtest="shotdata-s-7Zh"
													[(value)]="
														current_field.like
													"
													(selectionChange)="
														this.onResetSelectAvgShotOrigin()
													"
													class="select-group"
												>
													<mat-option
														*ngFor="
															let like of likes
														"
														[value]="like.value"
													>
														{{ like.name }}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
										<div
											fxLayout="row"
											fxLayout.lt-sm="column"
											fxLayout.lt-md="column"
											fxFlex="56%"
											fxFlex.lt-md="50%"
											fxFlex.lt-sm="50%"
											class="hide-mobile"
										>
											<div
												class="title-content fav mobile-bg-black"
												fxFlex="40%"
											>
												<div
													data-idtest="shotdata-t-6Ig"
													style="font-weight: 900"
													translate
												>
													お気に入り
												</div>
											</div>

											<mat-form-field
												appearance="outline"
												fxFlex="54%"
												fxFlex.lt-md="60%"
												fxFlex.lt-sm="60%"
												class="fav-field"
											>
												<mat-select
													data-idtest="shotdata-s-7Zh"
													[(value)]="
														current_field.like
													"
													(selectionChange)="
														this.onResetSelectAvgShotOrigin()
													"
													class="select-group"
												>
													<mat-option
														*ngFor="
															let like of likes
														"
														[value]="like.value"
													>
														{{ like.name }}
													</mat-option>
												</mat-select>
											</mat-form-field>
										</div>
									</div>
								</div>

								<div
									*ngIf="auth | aigauthis : 'user'"
									fxLayout="row"
									fxLayout.lt-sm="column"
									fxLayout.lt-md="column"
									fxLayoutAlign="space-between"
									style="background: #191919"
									class="lower-row mobile-bg-black"
								>
									<div
										fxLayout="row"
										fxLayout.lt-sm="column"
										fxLayout.lt-md="column"
										fxFlex="40%"
										fxFlex.lt-md="100%"
										fxFlex.lt-sm="100%"
									>
										<div
											class="title-content score mobile-bg-black"
											fxFlex="15%"
											fxFlex.lt-md="100%"
										>
											<div
												data-idtest="shotdata-t-9Lq"
												style="font-weight: 900"
												translate
											>
												スコア
											</div>
										</div>
										<div
											fxLayout="row"
											fxFlex="85%"
											class="mobile-w100"
										>
											<mat-form-field
												appearance="outline"
												fxFlex="47%"
												class="mobile-w50"
											>
												<mat-label
													><span
														data-idtest="shotdata-t-5Nh"
														translate
														>スコア 下限</span
													></mat-label
												>
												<input
													data-idtest="shotdata-i-8Gp"
													[(ngModel)]="
														current_field.score.from
													"
													matInput
													max="100"
													min="0"
													name="score_from"
													type="number"
													(change)="
														this.onResetSelectAvgShotOrigin()
													"
												/>
											</mat-form-field>

											<div
												class="hide-mobile"
												data-idtest="shotdata-t-7Sr"
												style="
													padding-right: 12px;
													display: flex;
													align-items: center;
												"
											>
												~
											</div>

											<mat-form-field
												appearance="outline"
												fxFlex="47%"
												class="mobile-w50"
											>
												<mat-label
													><span
														data-idtest="shotdata-t-5Ba"
														translate
														>スコア 上限</span
													></mat-label
												>
												<input
													data-idtest="shotdata-i-2Sg"
													[(ngModel)]="
														current_field.score.to
													"
													matInput
													max="100"
													min="0"
													name="score_to"
													type="number"
													(change)="
														this.onResetSelectAvgShotOrigin()
													"
												/>
												<button
													(click)="
														current_field.score.from = 0;
														current_field.score.to = 0;
														onFind()
													"
													aria-label="Clear"
													mat-button
													mat-icon-button
													matSuffix
												>
													<mat-icon>close</mat-icon>
												</button>
											</mat-form-field>
										</div>
									</div>
									<div
										fxLayout="row"
										fxFlex="85%"
										fxFlex.lt-md="100%"
										fxFlex.lt-sm="100%"
									>
										<div
											*ngIf="auth | aigauthis : 'trainer'"
											fxLayout="row"
											fxLayout.lt-sm="column"
											fxLayout.lt-md="column"
											fxFlex="50%"
											fxFlex.lt-md="50%"
											fxFlex.lt-sm="50%"
											class="hide-mobile"
										>
											<div
												class="title-content nickname mobile-bg-black hide-mobile"
												fxFlex="40%"
											>
												<div
													data-idtest="shotdata-t-2Me"
													style="font-weight: 900"
													translate
												>
													ニックネーム
												</div>
											</div>
											<mat-form-field
												appearance="outline"
												fxFlex.lt-sm="60%"
												fxFlex.lt-xl="54%"
												fxFlex.lt-md="60%"
											>
												<mat-label
													><span
														data-idtest="shotdata-t-3Xj"
														translate
														>ニックネーム</span
													></mat-label
												>
												<input
													data-idtest="shotdata-i-5Do"
													[(ngModel)]="
														current_field.nickname
													"
													autocomplete="off"
													matInput
													placeholder="{{
														'お名前' | translate
													}}"
													type="text"
													(change)="
														this.onResetSelectAvgShotOrigin()
													"
												/>
												<button
													(click)="
														current_field.nickname =
															''
													"
													aria-label="Clear"
													mat-button
													mat-icon-button
													matSuffix
												>
													<mat-icon>close</mat-icon>
												</button>
											</mat-form-field>
										</div>
										<!-- <div
											fxLayout="row"
											fxLayout.lt-sm="column"
											fxLayout.lt-md="column"
											fxFlex="56%"
											fxFlex.lt-md="50%"
											fxFlex.lt-sm="50%"
										>
											<div
												appearance="none"
												fxFlex="100%"
												fxFlex.lt-md="100%"
												fxFlex.lt-sm="100%"
												class="fav-field mobile-ckb-avgShot"
												style="
													display: flex;
													align-items: center;
													justify-content: center;
												"
											>
												<mat-checkbox
													[(ngModel)]="
														current_field.avgShot
													"
													name="avgShot"
													(change)="
														this.onResetSelectAvgShotOrigin()
													"
												>
													平均スイングデータ
													<input
														matInput
														style="display: none"
													/>
												</mat-checkbox>
											</div>
										</div> -->
									</div>
								</div>
								<div
									class="shot-search-button-wrapper mobile-bg-black"
									style="gap: 10px"
								>
									<button
										data-idtest="shotdata-b-1Rx"
										class="shot-search-button"
										(click)="onFind()"
										mat-raised-button
									>
										<mat-icon data-idtest="shotdata-a-5Gy"
											>search</mat-icon
										>
										<span
											data-idtest="shotdata-t-0Bw"
											translate
											>検索</span
										>
									</button>

									<!-- <button
										data-idtest="shotdata-b-1Rx"
										class="shot-search-button"
										(click)="onConfirmCreateShotAVG()"
										[disabled]="
											!this.selectedAvgInputShots.length
										"
										mat-raised-button
										style="min-width: 80px; width: 150px"
									>
										<span
											data-idtest="shotdata-t-0Bww"
											translate
											>平均スイング作 成</span
										>
									</button> -->
								</div>
							</div>
						</mat-expansion-panel>
					</mat-accordion>
					<div
						style="
							justify-content: space-between;
							display: flex;
							padding: 10px 0px;
							box-shadow: none;
							background: #242424;
						"
						class="mobile-bg-button mobile-result-title"
					>
						<!-- <mat-expansion-panel-header class="swing-data-result-header" fxLayout="column" fxFlex="50%"> -->
						<div class="section-bar" fxLayoutAlign="space-between">
							<div
								style="padding-left: 12px; font-weight: 900"
								fxLayout="row"
							>
								<mat-icon
									data-idtest="shotdata-a-5Sh"
									class="hide-mobile"
									>description</mat-icon
								>
								<mat-icon
									data-idtest="shotdata-a-5Sh"
									class="hide-pc"
									>search</mat-icon
								>
								<div
									data-idtest="shotdata-t-8Iu"
									style="align-self: center"
									translate
									class="hide-mobile"
								>
									スイングデータ検索結果
								</div>

								<div
									data-idtest="shotdata-t-8Iu"
									style="align-self: center"
									translate
									class="hide-pc"
								>
									検索結果
								</div>
							</div>
						</div>

						<div
							fxLayout="row"
							fxHide.lt-sm
							fxShow.lt-xl
							fxShow.xl
							fxHide.lt-md
						>
							<div
								class="title-content sort-fields mobile-bg-black"
								fxFlex="40%"
							>
								<div
									data-idtest="shotdata-t-1Mb"
									style="font-weight: 900"
									translate
								>
									並べ替え
								</div>
							</div>
							<mat-form-field
								appearance="outline"
								fxFlex="60%"
								style="padding-right: 0px"
							>
								<mat-select
									data-idtest="shotdata-s-6Ev"
									(selectionChange)="onFind()"
									[(value)]="current_field.sortType"
									class="select-group"
								>
									<mat-option
										*ngFor="let field of sortFields"
										[value]="field.value"
									>
										{{ field.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
						<div
							fxLayout="row"
							fxHide.lt-sm
							fxHide.lt-xl
							fxHide.xl
							fxShow.lt-md
						>
							<div
								class="title-content sort-fields mobile-bg-button"
								fxFlex="40%"
							>
								<div style="font-weight: normal" translate>
									並べ替え
								</div>
							</div>
							<mat-form-field
								appearance="outline"
								fxFlex="60%"
								style="padding-right: 12px; padding-top: 5px"
							>
								<mat-select
									(selectionChange)="onFind()"
									[(value)]="current_field.sortType"
									class="select-group"
								>
									<mat-option
										*ngFor="let field of sortFieldsShort"
										[value]="field.value"
									>
										{{ field.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>

						<div
							fxLayout="row"
							fxShow.lt-sm
							fxHide.lt-xl
							fxHide.xl
							fxHide.lt-md
							style="padding-right: 12px; align-items: center"
						>
							<div
								class="title-content sort-fields"
								style="
									background-color: transparent;
									padding-top: 0px;
								"
							>
								<div style="font-weight: normal" translate>
									並べ替え
								</div>
							</div>
							<mat-form-field
								appearance="outline"
								style="
									padding-right: 0px;
									padding-top: 0px;
									padding-bottom: 0px;
									width: 100px;
								"
								class="mobile-mff-order"
							>
								<mat-select
									(selectionChange)="onFind()"
									[(value)]="current_field.sortType"
									class="select-group"
								>
									<mat-option
										*ngFor="let field of sortFieldsShort"
										[value]="field.value"
									>
										{{ field.name }}
									</mat-option>
								</mat-select>
							</mat-form-field>
						</div>
					</div>
				</div>

				<div fxLayout="row" fxLayoutAlign="center">
					<mat-paginator
						#paginator
						(page)="Page($event)"
						[length]="count"
						[pageSize]="size"
						style="background-color: rgba(255, 255, 255, 0)"
					>
					</mat-paginator>
				</div>

				<div
					fxLayout="row"
					class="shot-items mobile-bg-table-header"
					style="
						height: 100%;
						overflow-x: hidden;
						overflow-y: hidden;
						background: #3a3a3a;
					"
					#table_header
				>
					<div
						class="table-title"
						fxFlex="9%"
						fxFlex.lt-md="10%"
						fxFlex.lt-sm="20%"
						class="mobile-w15"
						fxLayoutAlign="center center"
					></div>
					<div
						data-idtest="shotdata-t-7Xl"
						class="table-title mobile-bg-table-header"
						fxFlex="18%"
						fxFlex.lt-md="46%"
						fxFlex.lt-sm="46%"
						fxLayoutAlign="center center"
						fxHide.lt-md
						fxHide.lt-sm
						translate
					>
						ニックネーム
					</div>
					<div
						data-idtest="shotdata-t-0Ff"
						class="table-title mobile-bg-table-header"
						fxFlex="18%"
						fxFlex.lt-md="26%"
						fxFlex.lt-sm="27%"
						class="mobile-w25"
						fxLayoutAlign="center center"
						translate
					>
						日時
					</div>
					<div
						data-idtest="shotdata-t-3Ia"
						class="table-title mobile-w15 mobile-bg-table-header"
						fxFlex="10%"
						fxFlex.lt-md="18%"
						fxFlex.lt-sm="14%"
						fxLayoutAlign="center center"
						translate
					>
						クラブ
					</div>
					<div
						data-idtest="shotdata-t-8Ns"
						class="table-title mobile-w15 mobile-bg-table-header"
						fxFlex="9%"
						fxFlex.lt-md="18%"
						fxFlex.lt-sm="16%"
						fxLayoutAlign="center center"
						translate
					>
						スコア
					</div>
					
					<div
						class="table-title mobile-bg-table-header"
						fxFlex="15%"
						fxFlex.lt-md="18%"
						fxFlex.lt-sm="16%"
						fxLayoutAlign="center center"
						fxLayout="column"
						class="col-distance-header mobile-w15"
					>
						<div data-idtest="shotdata-t-5Dc" translate>飛距離</div>
						<div
							data-idtest="shotdata-t-1Es"
							style="font-size: 10px; padding-top: 5px"
							translate
						>
							(ヤード)
						</div>
					</div>
					<!--	<div class="table-title" fxFlex="10%" fxFlex.lt-md="80px" fxFlex.lt-sm="80px" fxLayoutAlign="center center">ミート率</div>
							<div class="table-title" fxFlex="9%" fxFlex.lt-md="100px" fxFlex.lt-sm="100px" fxLayoutAlign="center center">ヘッドスピード</div> -->
					<div
						class="table-title2 mobile-bg-table-header hide-mobile"
						fxFlex="10%"
						fxFlex.lt-md="0%"
						fxFlex.lt-sm="0%"
					></div>
					<div
						class="table-title2 mobile-bg-table-header hide-mobile"
						fxFlex="10%"
						fxFlex.lt-md="0%"
						fxFlex.lt-sm="0%"
					></div>
					<div
						class="table-title2 col-button-data mobile-w15 mobile-bg-table-header"
						fxFlex="10%"
					></div>
				</div>

				<div
					*ngFor="let item of results; let last = last"
					class="shot-items"
					matTooltip="{{ description(item) }}"
				>
					<div
						fxLayout="row"
						style="height: 100%"
						class="item-row"
						hover-class="is-hover"
					>
						<!--	<div fxLayout="row" style="height: 100%;" (change)="last(last)"  class="item-row" hover-class="is-hover"> -->

						<div
							fxFlex="9%"
							fxFlex.lt-md="10%"
							fxFlex.lt-sm="20%"
							class="mobile-w15"
							style="
								text-align: center;
								border-bottom: 1px solid #3a3a3a;
								display: flex;
								gap: 5px;
								justify-content: center;
							"
						>
							<!-- <input
								type="checkbox"
								style="width: 18px"
								[style.cursor]="
									isValigInputAVGShot(item)
										? 'pointer'
										: 'auto'
								"
								[style.opacity]="isAvgShot(item) ? 0 : 1"
								[disabled]="!isValigInputAVGShot(item)"
								(click)="onSelectAVGShotOrigin(item)"
								[checked]="isAvgInputShot(item)"
							/> -->
							<button (click)="setLike(item)" mat-icon-button>
								<mat-icon
									*ngIf="getLike(item)"
									class="material-icons"
									style="color: #ffd500"
									>star</mat-icon
								>
								<mat-icon
									*ngIf="!getLike(item)"
									class="material-icons"
									style="color: #b9b9b9"
									>star</mat-icon
								>
							</button>
						</div>
						<div
							data-idtest="shotdata-t-0Pl"
							fxFlex="18%"
							fxFlex.lt-md="46%"
							fxFlex.lt-sm="46%"
							fxLayoutAlign="center center"
							class="shot-item"
							fxHide.lt-md
							fxHide.lt-sm
						>
							{{ isAvgShot(item) ? "平均" : nickname(item) }}
						</div>
						<!-- <div fxFlex="18%" fxFlex.lt-md="26%" fxFlex.lt-sm="27%" fxLayoutAlign="center center" class="shot-item" style="text-align: left;"><span>20{{name(item).substr(0,8)}}</span><span>{{name(item).substr(8,3)}}時</span></div> -->
						<div
							fxLayout.lt-sm="column"
							fxFlex="18%"
							fxFlex.lt-md="26%"
							fxFlex.lt-sm="27%"
							fxLayoutAlign="center center"
							fxLayoutAlign.lt-sm="center"
							class="shot-item mobile-w25 mobile-col-datetime"
							style="text-align: left"
						>
							<span data-idtest="shotdata-t-7Cx"
								>{{ name(item).substr(0, 10) }}</span
							>
							<span class="times-md hide-mobile"
								>{{ name(item).substr(11, 5)
								}}<span data-idtest="shotdata-t-4Nd" translate
									>時</span
								></span
							>
							<span class="times" class="hide-pc">{{
								name(item).substr(11, 5)
								}}<span data-idtest="shotdata-t-4Nd" translate
									>時</span
							></span	>
						</div>
						<div
							fxFlex="10%"
							fxFlex.lt-md="18%"
							fxFlex.lt-sm="14%"
							fxLayoutAlign="center center"
							class="shot-item mobile-w15"
						>
							<span
								data-idtest="shotdata-t-5Kk"
								class="club-span mobile-club-span"
								>{{ clubName(item) }}</span
							>
						</div>
						<div
							data-idtest="shotdata-t-9Nb"
							fxFlex="9%"
							fxFlex.lt-md="18%"
							fxFlex.lt-sm="16%"
							fxLayoutAlign="center center"
							class="shot-item score mobile-w15 mobile-bg-transparent mobile-font-16"
						>
							{{ isAvgShot(item) ? "-" : score(item) }}
						</div>
						<div
							data-idtest="shotdata-t-4Zg"
							fxFlex="15%"
							fxFlex.lt-md="18%"
							fxFlex.lt-sm="16%"
							fxLayoutAlign="center center"
							class="col-distance-data shot-item yard mobile-w15 mobile-font-16"
							style="font-weight: bold"
						>
							{{ isAvgShot(item) ? "-" : isYard(item) }}
						</div>

						<div
							fxFlex="10%"
							fxFlex.lt-md="12%"
							fxFlex.lt-sm="17%"
							fxLayoutAlign="center center"
							style="
								text-align: center;
								padding-right: 0px;
								border-bottom: 1px solid #3a3a3a;
							"
							class="col-button-header mobile-w15 mobile-pl-04rem"
						>
							<button
								data-idtest="shotdata-b-2Ix"
								(click)="
									isAvgShot(item)
										? onDetailShotAvg(item)
										: onDetail(item)
								"
								class="detail-btn mobile-bg-button"
								mat-raised-button
							>
								<img
									src="/icons/right.png"
									fxHide.lt-sm
									fxHide.lt-md
									style="display: inherit; width: 15px"
								/>
								<span data-idtest="shotdata-t-6Df" translate
									>詳細</span
								>
							</button>
						</div>

						<div
							fxFlex="10%"
							fxHide.lt-md
							fxHide.lt-sm
							fxLayoutAlign="center center"
							class="shot-item"
						>
							<button
								data-idtest="shotdata-b-0Xa"
								(click)="onViewMemo(item._id)"
								hover-class="is-hover"
								class="memo-btn have"
								mat-raised-button
							>
								<img
									src="/icons/memo.png"
									style="display: inherit; width: 15px"
								/>
								<span
									data-idtest="shotdata-t-7Fp"
									style="padding-left: 8px"
									translate
									>メモ</span
								>
							</button>
						</div>
						<div
							fxFlex="10%"
							fxHide.lt-md
							fxHide.lt-sm
							fxLayoutAlign="center center"
							class="shot-item"
						>
							<button
								data-idtest="shotdata-b-7Ty"
								(click)="onDelete($event, item._id)"
								class="delete-btn"
								mat-raised-button
								id="mat-remove-button"
							>
								<mat-icon data-idtest="shotdata-a-1Bm"
									>delete</mat-icon
								>
								<span
									data-idtest="shotdata-t-4Id"
									style="padding-left: 8px"
									translate
									>削除</span
								>
							</button>
						</div>
					</div>
				</div>
				<div fxLayout="row" fxLayoutAlign="center">
					<mat-paginator
						#paginator
						(page)="Page($event)"
						[pageIndex]="pageIndex"
						[length]="count"
						[pageSize]="size"
						style="background-color: rgba(255, 255, 255, 0)"
					>
					</mat-paginator>
				</div>
			</mat-card-content>
		</mat-card>
		<mat-spinner *ngIf="isProgress" class="spinner"></mat-spinner>
	</div>
</ng-container>
